module.exports = __webpack_public_path__ + "static/media/socketio.93f1fcc4.svg";